import { SendCommandDialog } from "modules/field-mgmt/sections/device/software-package/SendCommandDialog";
import { MESSAGE_TYPE_TEMPLATE } from "modules/field-mgmt/sections/device/software-package/SoftwarePackageCommands";
import { SoftwarePackageCommandsBody } from "modules/field-mgmt/sections/device/software-package/SoftwarePackageCommandsBody";
import { useCallback, useState } from "react";
import { matchPath, useNavigate } from "react-router-dom";

import { FormMethods } from "@bps/fluent-ui";
import {
  ChannelPreference,
  DeviceCommand
} from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { useSoftwarePackageCommandJson } from "@libs/api/gateways/field/field-ops-gateway.hooks";

import { SelectSoftwarePackageFormValues } from "../../../rings/rollout-package/add/selectSoftwarePackageUtils";
import { BulkSendCommandFormValues } from "../../formTypes";

interface SelectSoftwarePackageCommandProps {
  softwarePackage?: SelectSoftwarePackageFormValues;
  formActions: FormMethods<BulkSendCommandFormValues>;
}

export const SelectSoftwarePackageCommand: React.FC<SelectSoftwarePackageCommandProps> = ({
  softwarePackage,
  formActions
}) => {
  const { data: commandJson } = useSoftwarePackageCommandJson(
    softwarePackage?.softwarePackageVersionId
  );

  const [dispatchFormShown, setDispatchFormShown] = useState(false);
  const [formData, setFormData] = useState<DeviceCommand>();
  const navigate = useNavigate();
  const match = matchPath(
    "/system/plt/bulk-actions/:command",
    location.pathname
  );

  const commandArg = match?.params?.command;

  const getMessageTypeString = () => {
    const command = commandJson?.find(command => command.title === commandArg);

    return (
      command?.["x-messageType"] ??
      MESSAGE_TYPE_TEMPLATE.replace("{type}", commandArg!)
    );
  };

  const onSubmit = async ({ formData }: any) => {
    // We explicitly have any type as form data type changes with command type.
    const command = {
      fieldDeviceId: undefined,
      channelPreference: ChannelPreference.RealtimeWithQueuedFallback, // Default to RealtimeWithQueuedFallback
      targetSoftwarePackageCode: softwarePackage?.code,
      routedMessageData: {
        messageType: getMessageTypeString(),
        commandName: commandArg,
        value: JSON.stringify({ ...formData })
      }
    } as DeviceCommand;
    setFormData(command);
    setDispatchFormShown(true);
  };

  const onCommandChange = useCallback(
    (command: string) => {
      navigate(`/system/plt/bulk-actions/${command}`);
    },
    [navigate]
  );

  const onDispatch = useCallback(async () => {
    formActions.setValue("smartDeviceCommandMessage", formData);
    formActions.submit();
    setDispatchFormShown(false);
  }, [formActions, formData]);

  return (
    <>
      <SoftwarePackageCommandsBody
        commandJson={commandJson}
        commandArg={commandArg}
        handleSubmit={onSubmit}
        handleCommandChange={onCommandChange}
        renderCommandResult={false}
      />
      <SendCommandDialog
        isShown={dispatchFormShown}
        formData={formData}
        onDismiss={() => {
          setDispatchFormShown(false);
        }}
        onDispatch={onDispatch}
        setFormData={setFormData}
      />
    </>
  );
};
